import * as doorVisual from '../../constants/doorVisual'
import _ from 'lodash'

const initialState = {
    wysokosc: 2099,
    szerokosc: 1030,
    skala: 40,
    model_drzwi: "Mszczuj Termo",
    receptury: undefined,
    kierunek_otwieranie: "lewe|na zewnątrz",
    kierunek: "lewe",
    otwieranie: "na zewnątrz"
}

const allFieldsToFloat = obj => {
    const ret = {}
    _.each(obj, (val, key) => ret[key] = isNaN(parseFloat(val)) ? val : parseFloat(val))
    return ret
}

const kierunekOtwieranie = obj => {
    const arr = obj.kierunek_otwieranie.split('|')
    obj.kierunek = arr[0]
    obj.otwieranie = arr[1]
    return obj
}

export default (state = initialState, action) => {
    switch (action.type) {
        case doorVisual.DOOR_VISUAL_CHANGE_VALUES:
            return kierunekOtwieranie(allFieldsToFloat(action.payload))
        default:
            return state
    }
}